import {
  RecentlyUsed,
  AvailableCustomers,
  UserActions,
} from "@entrecode/statsapp-components";

export const Overview = (props) => {
  return (
    <div className="px-4">
      <div id="top">
        <div className="w-full flex justify-end">
          <UserActions env={undefined} token={undefined} />
        </div>
        <RecentlyUsed />
      </div>
      <AvailableCustomers />
    </div>
  );
};
